import { PersonalInfo, SkillGroup, Project, ResumeItem } from '../types';

export const personalInfo: PersonalInfo = {
  name: "Aditya Bharti",
  title: "Data Analyst",
  bio: "Data Analyst with hands-on experience in Python, SQL, Power BI, ETL and exploratory data analysis. I turn messy, real-world datasets into clean pipelines and dashboards people actually trust.",
  email: "adityabharti6088@gmail.com",
  linkedin: "https://www.linkedin.com/in/aditya-bharti/",
  profileImage: "/profile.webp",
};

export const contactData = {
  address: "Pune, Maharashtra, India",
  profiles: {
    github: "https://github.com/adityabharti83",
    linkedin: "https://www.linkedin.com/in/aditya-bharti/",
  },
};

// Straight from the resume. `group` is the schema-style key, `label` the resume heading.
export const skillGroups: SkillGroup[] = [
  {
    group: "languages",
    label: "Programming & Query Languages",
    items: ["Python", "SQL"],
  },
  {
    group: "data_analysis",
    label: "Data Analysis",
    items: ["Pandas", "NumPy", "Data Cleaning", "EDA", "Statistics", "Data Visualization"],
  },
  {
    group: "bi_analytics",
    label: "BI & Analytics",
    items: ["Power BI", "DAX", "Excel", "Tableau", "Looker"],
  },
  {
    group: "data_engineering",
    label: "Data Engineering",
    items: ["ETL", "Data Pipelines", "Data Validation", "Data Modeling"],
  },
  {
    group: "cloud_platforms",
    label: "Cloud & Data Platforms",
    items: ["BigQuery", "GCP", "Snowflake"],
  },
  {
    group: "business_analytics",
    label: "Business Analytics",
    items: ["Business Analysis", "Data Storytelling", "KPI Analysis"],
  },
  {
    group: "dev_automation",
    label: "Development & Automation",
    items: ["Git", "GitHub", "APIs", "Generative AI", "AI-assisted Analytics"],
  },
];

export const projects: Project[] = [
  {
    id: "1",
    title: "Pune Transit Schedule Analytics",
    description:
      "Built a Python pipeline to clean and transform real PMPML GTFS schedule data, then validated and modeled it into an analysis-ready dataset. Developed an interactive Power BI dashboard covering network KPIs, route/stop coverage, headways, and service patterns.",
    technologies: ["Python", "SQL", "SQLite", "Pandas", "Power BI", "Pytest", "GTFS"],
    repoUrl: "https://github.com/adityabharti83/pune-transit-monitor",
    featured: true,
  },
  {
    id: "2",
    title: "Airbnb Data Analysis & Visualization Dashboard",
    description:
      "Analyzed 1M+ Airbnb listing records with Python and SQL to surface pricing, availability, host, and location-based trends. Built Power BI dashboards and KPI reports after a full cleaning, transformation, and feature-engineering pass.",
    technologies: ["Python", "SQL", "Pandas", "Power BI", "Data Visualization"],
    repoUrl: "https://github.com/adityabharti83/airbnb-market-analytics",
    featured: true,
  },
];

export const projectMetrics: Record<string, { label: string; value: string }[]> = {
  "1": [
    { label: "routes", value: "627" },
    { label: "stops", value: "6,696" },
    { label: "trips", value: "15,138" },
    { label: "stop_times", value: "627K+" },
  ],
  "2": [
    { label: "listings", value: "1M+" },
    { label: "dimensions", value: "price · availability · host · geo" },
  ],
};

export const resumeItems: ResumeItem[] = [
  {
    id: "1",
    title: "Data Engineer Apprentice",
    organization: "thinkbridge",
    period: "Nov 2025 – Dec 2025",
    description:
      "Built ETL pipelines in Python and SQL for ingestion, transformation, validation, and preparation of analytics-ready datasets for business reporting.",
    type: "experience",
    skills: ["Python", "SQL", "ETL", "Git", "CI/CD", "APIs"],
    achievements: [
      "Optimized SQL queries and applied Git/CI-CD practices for maintainable, version-controlled data workflows",
      "Integrated external APIs and cloud data sources, with cleaning and validation at the boundary",
    ],
  },
  {
    id: "2",
    title: "Data Analytics Intern",
    organization: "Clustor Computing",
    period: "Jan 2025 – Oct 2025",
    description:
      "Analyzed structured datasets with Python, Pandas, and SQL to identify trends, anomalies, and data quality issues, then shipped the resulting dashboards.",
    type: "experience",
    skills: ["Python", "Pandas", "SQL", "Power BI", "EDA"],
    achievements: [
      "Cleaned, transformed, and validated datasets before they reached a report",
      "Developed interactive Power BI dashboards and KPI reports for performance monitoring",
    ],
  },
  {
    id: "3",
    title: "B.E. — Computer Software Engineering",
    organization: "P. R. Pote (Patil) College of Engineering & Management, Amravati",
    period: "Nov 2021 – Jul 2025",
    description: "CGPA: 8.68",
    type: "education",
    skills: [],
  },
  {
    id: "4",
    title: "Data Analysis",
    organization: "AccioJob",
    period: "Sept 2026",
    description: "",
    type: "certification",
    skills: [],
  },
  {
    id: "5",
    title: "Data Science & Analytics",
    organization: "HP LIFE",
    period: "Feb 2026",
    description: "",
    type: "certification",
    skills: [],
  },
  {
    id: "6",
    title: "Cloud Foundations",
    organization: "AWS Academy",
    period: "Feb 2024",
    description: "",
    type: "certification",
    skills: [],
  },
];

export const resumeCategories = [
  { id: "all", label: "all", icon: "*" },
  { id: "experience", label: "experience", icon: ">" },
  { id: "education", label: "education", icon: "#" },
  { id: "certification", label: "certifications", icon: "+" },
];
